export default {
  version: 'hotfix/IDCLOUD-2861-regenerate-graphql-generated',
  compilation: '293016'
}



//////////////////
// WEBPACK FOOTER
// ./version.js
// module id = 1478
// module chunks = 22